export { default } from './PosterLayout';
